<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<section epub:type="division">
<p class="c12"><a id="page_xvi"></a><strong class="calibre1">CUE-TITLES</strong></p>
<p class="c24"><strong class="calibre1">A. Manuscript locations</strong></p>
<div class="table">
<table class="c19" style="width:100%;font-size:1em;">
<tbody><tr class="t348_row" style="vertical-align:top;"><td class="c25" style="vertical-align:top;">GSArchiv</td>
<td class="c26" style="vertical-align:top;">Goethe-und Schiller-Archiv, Weimar</td>
</tr>
<tr class="t348_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">Lazarus</td>
<td class="c23" style="vertical-align:top;"><p class="jus">Mr George Lazarus</p></td>
</tr>
<tr class="t348_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">NWU</td>
<td class="c23" style="vertical-align:top;"><p class="jus">Northwestern University</p></td>
</tr>
<tr class="t348_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">UCB</td>
<td class="c23" style="vertical-align:top;"><p class="jus">University of California at Berkeley</p></td>
</tr>
<tr class="t348_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">UCLA</td>
<td class="c23" style="vertical-align:top;"><p class="jus">University of California at Los Angeles</p></td>
</tr>
<tr class="t348_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">UNM</td>
<td class="c23" style="vertical-align:top;"><p class="jus">University of New Mexico</p></td>
</tr>
<tr class="t348_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">UT</td>
<td class="c23" style="vertical-align:top;"><p class="jus">University of Texas at Austin</p></td>
</tr>
<tr class="t348_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">UTul</td>
<td class="c23" style="vertical-align:top;"><p class="jus">University of Tulsa</p></td>
</tr>
<tr class="t348_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">YU</td>
<td class="c23" style="vertical-align:top;"><p class="jus">Yale University</p></td>
</tr>
</tbody></table>
</div>
<p class="c24"><strong class="calibre1">B. Printed works</strong></p>
<p class="c27">(The place of publication, here and throughout, is London unless otherwise stated.)</p>
<div class="table">
<table class="c19" style="width:100%;font-size:1em;">
<tbody><tr class="t351_firstrow" style="vertical-align:top;"><td class="c25" style="vertical-align:top;"><em class="calibre4">Aaron's Rod</em></td>
<td class="c26" style="vertical-align:top;"><p class="jus">D. H. Lawrence. <em class="calibre4">Aaron's Rod</em>. Ed. Mara Kalnins. Cambridge: Cambridge University Press, 1988.</p></td>
</tr>
<tr class="t351_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">Dennis</td>
<td class="c23" style="vertical-align:top;"><p class="jus">George Dennis. <em class="calibre4">The Cities and Cemeteries of Etruria</em>. 2nd edn. 2 volumes. J. Murray, 1878.</p></td>
</tr>
<tr class="t351_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">Ducati</td>
<td class="c23" style="vertical-align:top;"><p class="jus">Pericle Ducati. <em class="calibre4">Etruria Antica</em>. 2 volumes. Torino: G. B. Paravia, 1925.</p></td>
</tr>
<tr class="t351_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;"><em class="calibre4">Letters</em>, iii.</td>
<td class="c23" style="vertical-align:top;"><p class="jus">James T. Boulton and Andrew Robertson, eds. <em class="calibre4">The Letters of D. H. Lawrence</em>. Volume III. Cambridge: Cambridge University Press, 1984.</p></td>
</tr>
<tr class="t351_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;"><em class="calibre4">Letters</em>, v.</td>
<td class="c23" style="vertical-align:top;"><p class="jus">James T. Boulton and Lindeth Vasey, eds. <em class="calibre4">The Letters of D. H. Lawrence</em>. Volume V. Cambridge: Cambridge University Press, 1989.</p></td>
</tr>
<tr class="t351_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;"><em class="calibre4">Letters</em>, vi.</td>
<td class="c23" style="vertical-align:top;"><p class="jus">James T. Boulton and Margaret H. Boulton with Gerald M. Lacy, eds. <em class="calibre4">The Letters of D. H. Lawrence</em>. Volume VI. Cambridge: Cambridge University Press, 1991.</p></td>
</tr>
<tr class="t351_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;"><em class="calibre4"><a class="calibre5" id="page_xvii"></a>OED</em></td>
<td class="c23" style="vertical-align:top;"><p class="jus">Sir James A. H. Murray and others, eds<em class="calibre4">. A New English Dictionary on Historical Principles</em>. 10 volumes. Oxford University Press, 1884–1928.</p></td>
</tr>
<tr class="t351_row" style="vertical-align:top;"><td class="c22" style="vertical-align:top;"><em class="calibre4">Phoenix</em></td>
<td class="c23" style="vertical-align:top;"><p class="jus">Edward D. McDonald, ed. <em class="calibre4">Phoenix: The Posthumous Papers of D.H. Lawrence</em>. New York: Viking Press, 1936.</p></td>
</tr>
<tr class="t351_lastrow" style="vertical-align:top;"><td class="c22" style="vertical-align:top;">Roberts</td>
<td class="c23" style="vertical-align:top;"><p class="jus">Warren Roberts. <em class="calibre4">A Bibliography of D.H. Lawrence</em>. 2nd edn. Cambridge: Cambridge University Press, 1982.</p></td>
</tr>
</tbody></table>
</div>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0008.vue?287106f2